<template>
    <div>
    <div>
    <section style="background: #fff; padding: 40px;">

   
<div class="article-container fort-body">
  <img src="/img/laurel-headshot.png" alt="Description" class="circular-image"/>
 <span v-html="block.body"></span>
 <img src="/img/laurel-signature.png" style="max-width: 200px;"/>
<p>
President | Spacesaver Corporation
        </p>
</div>
    </section>


    <section v-if="block.BottomTitle && block.BottomBody" style="background-color: rgba(156, 179, 189, 0.3); padding: 40px;">
        <div style="text-align: center;">
        <h2 style="font-size: 24px; font-weight: bold;">{{ block.BottomTitle }}</h2>
        <img src="/img/teal-line.svg" class="mb20 mt20"/>
        <div class="fort-body">
<p v-html="block.BottomBody">

</p>
</div>
        </div >
       

        <div class="grid-container" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-top: 30px;">
            <div v-for="item, i in block.CompanyAnniversary" :key="i">
        <div class="box" style="width: 100%; display: flex; justify-content: center; text-align: center; background-color: #ffffff; padding: 15px; margin: 0; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
            <p style="margin: 0; font-size: 15px; color: #333;">
                <span class="years">{{item.Length + " "}}</span><span class="ac-name">| {{item.CompanyName}}</span>
            </p>
        </div>
    </div>
        
    </div>




    </section>
    
</div>
<divider v-if="block.BottomDivider" />
</div>
  </template>
  
  <script>
  import Divider from "@/components/FortBuilder/Divider.vue";
  export default {
    name: "IntroLetter",
    data() {
        return {
        anniversaries: [
            {
                time: "20",
                name: "Patterson Pope"
            },
            {
                time: "32",
                name: "Heritage Business Interiors"
            },
            {
                time: "36",
                name: "The Systemcenter Inc."
            },
            {
                time: "28",
                name: "Ergo Office Plus"
            },
            {
                time: "29",
                name: "STORAGELogic"
            }
        ]
        };
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    components: {
        Divider
    },
    methods: {
      
    },
  };
  </script>
  
  <style scoped>

        .container {
            display: flex;
            align-items: flex-start;
            padding: 0;
        }

        .image-container {
            flex-shrink: 0;
            margin-left: 20px;
        }

        .round-image {
            width: 200px;
            height: 200px;
            border-radius: 50%;
            object-fit: cover;
            shape-outside: circle(50%);
            float: right;
        }

        .text-container {
            flex-grow: 1;
            text-align: justify;
        }

        p {
            margin: 0 0 1em 0;
            line-height: 1.6;
        }

        @media (max-width: 768px) {
            .grid-container {
                grid-template-columns: 1fr 1fr !important; /* Two columns for tablets */
                gap: 15px !important;
            }
            .box {
                padding: 15px !important;
                margin: 0 !important;
            }
        }
        @media (max-width: 480px) {
            .grid-container {
                grid-template-columns: 1fr !important; /* One column for mobiles */
                gap: 10px !important;
            }
            .box {
                padding: 10px !important;
                margin: 0 !important;
            }
        }
/* start */

.article-container {
  /* Add any necessary container styles like width, padding, etc. */
}

.circular-image {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  float: right;
  margin-left: 15px;
  shape-outside: circle(); /* More precise wrapping */
  shape-margin: 15px;
}
.years{
    font-size: 15px;
    font-weight: bold;
}
.ac-name{
    font-size: 15px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 30px;
}

.box {
  background-color: #ffffff;
  padding: 15px;
  margin: 0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  min-height: 80px; /* Adjust value as needed */
  display: flex;
  align-items: center;
}
</style>